// client/src/utils/pdfForms.js
import api from './api';

function extractFilename(headerValue) {
    if (!headerValue) return '';
    const match = headerValue.match(/filename\*=UTF-8''([^;]+)|filename=\"?([^\";]+)\"?/i);
    return decodeURIComponent(match?.[1] || match?.[2] || '');
}

export async function listPdfForms() {
    const { data } = await api.get('/pdf-forms');
    return data;
}

export async function createPdfForm(templateId) {
    const { data } = await api.post('/pdf-forms', { templateId });
    return data;
}

export async function fetchPdfForm(id) {
    const { data } = await api.get(`/pdf-forms/${id}`);
    return data;
}

export async function updatePdfForm(id, valuesJson) {
    const { data } = await api.put(`/pdf-forms/${id}`, { valuesJson });
    return data;
}

export async function submitPdfForm(id) {
    const { data } = await api.post(`/pdf-forms/${id}/submit`);
    return data;
}

export async function reopenPdfForm(id) {
    const { data } = await api.post(`/pdf-forms/${id}/reopen`);
    return data;
}

function normalizeRecipients({ toEmail, toEmails }) {
    if (Array.isArray(toEmails)) {
        return toEmails.map((email) => String(email || '').trim()).filter(Boolean);
    }
    return toEmail ? [String(toEmail).trim()].filter(Boolean) : [];
}

export async function sharePdfFormByEmail(id, { toEmail, toEmails }) {
    const recipients = normalizeRecipients({ toEmail, toEmails });
    const { data } = await api.post(`/pdf-forms/${id}/share-email`, { toEmails: recipients });
    return data;
}

export async function storeCachedPdfFormExport(id, { pdfBlob, filename }) {
    const formData = new FormData();
    formData.append('pdf', pdfBlob, filename || `form-${id}.pdf`);
    if (filename) formData.append('filename', filename);
    const { data } = await api.post(`/pdf-forms/${id}/export-cache`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data;
}

export async function downloadCachedPdfFormExport(id) {
    const response = await api.get(`/pdf-forms/${id}/export-cache`, { responseType: 'blob' });
    return {
        blob: response.data,
        filename: extractFilename(response.headers['content-disposition']) || `form-${id}.pdf`,
    };
}

export async function exportPdfForm(id, overlays) {
    const response = await api.post(`/pdf-forms/${id}/export`, { overlays }, { responseType: 'blob' });
    return {
        blob: response.data,
        filename: extractFilename(response.headers['content-disposition']) || `form-${id}.pdf`,
    };
}
